import React from "react";
import LoadingIcon from "../../assets/LoadingIcon";

function SimpleButton({ title, onClick, isBusy, bgColor, textColor }) {
  return (
    <button
      className={`${
        isBusy === true ? "opacity-60" : ""
      } ${bgColor} ${textColor} font-bold uppercase text-sm px-6 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150`}
      onClick={onClick}
      disabled={isBusy === true}
    >
      <div className="flex flex-row">
        {isBusy === true ? <LoadingIcon color="text-neutral" /> : null}
        {title}
      </div>
    </button>
  );
}

export default SimpleButton;
